import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { getFilteredCommandBarRoutes } from "@/config/sitemap";
import { useTenant } from "@/contexts/tenant-provider";
import { useUser } from "@/contexts/user-provider";
import { UserTiny } from "@/types/user";
import { useRecentItemsStore } from "@/stores/recent-patients-store";
export function getRecentPages(): string[] {
  return useRecentItemsStore.getState().getRecentPages();
}
export function getRecentPatients(tenant: string): UserTiny[] {
  return useRecentItemsStore.getState().getRecentPatients(tenant);
}
export function usePageViewTracking() {
  const $ = _c(8);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    tenant
  } = useTenant();
  const {
    currentUser
  } = useUser();
  let t0;
  if ($[0] !== pathname || $[1] !== tenant) {
    t0 = () => {
      const tenantSubdomain = pathname.split("/")[1];
      if (!tenantSubdomain) {
        return;
      }
      const pathnameWithoutTenant = pathname.replace(/^\/[^/]+/, "");
      if (/\/[^/]*\/\d+/.test(pathname)) {
        return;
      }
      const matchingPage = getFilteredCommandBarRoutes(tenant).find(page => pathname === page.route || pathnameWithoutTenant === page.route);
      if (!matchingPage?.route) {
        return;
      }
      useRecentItemsStore.getState().updateRecentPages(matchingPage.route);
    };
    $[0] = pathname;
    $[1] = tenant;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== currentUser || $[4] !== pathname || $[5] !== searchParams || $[6] !== tenant) {
    t1 = [pathname, searchParams, tenant, currentUser];
    $[3] = currentUser;
    $[4] = pathname;
    $[5] = searchParams;
    $[6] = tenant;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  useEffect(t0, t1);
}
export function updateRecentPatients(patient: UserTiny) {
  const pathname = window.location.pathname;
  const tenant = pathname.split("/")[1];
  if (!tenant) return;
  useRecentItemsStore.getState().updateRecentPatients(tenant, patient);
}